import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/partner/$organization/users/')({
  component: () => <Navigate replace search to="/bo/users" />,
})
